export const GROUP_MEETING_ROUTE_NAMES = {
  MY_MEETING: "myGroupMeeting",
  CREATE: "groupMeetingCreate",
  // Keeps the legacy name: ManageMeetingMeetingList routes every
  // group_meeting row to "groupMeeting".
  MANAGE: "groupMeeting",
  EDIT: "groupMeetingEdit",
} as const;

export type GroupMeetingRouteName =
  (typeof GROUP_MEETING_ROUTE_NAMES)[keyof typeof GROUP_MEETING_ROUTE_NAMES];
